import moment from 'moment';
// import 'moment/locale/ar';
import 'moment/locale/he';
import 'moment/locale/en-au';
import {Logging} from "../log";

export const parseDate = (date: string | Date | null | undefined, locale: string, format?: string, ignoreLocale?: boolean): string => {
    if(!date) return '- - -';
    if(typeof date === 'string'){
        if(!date.length) return '- - -';
        date = date.substring(0, '2023-08-04T00:00:00.000'.length);
        const parsedDate = new Date(date.endsWith('Z') ? date : `${date}Z`);
        if(ignoreLocale){
            return moment(parsedDate).format(format ?? 'L');
        }else{
            return moment(parsedDate).locale(locale).format(format ?? 'L');
        }
    }else{
        return moment(date).locale(locale).format(format ?? 'L');
    }
}

export const parseDateInDate = (date: string | null | undefined, locale: string): Date | null => {
    if(!date || !date.length) return null;
    const parsedDate = new Date(date.endsWith('Z') ? date : `${date}Z`);
    return moment(parsedDate).locale(locale).toDate();
}

export const isExpired = (date: string, locale: string): boolean => {
    if(!date || !date.length) return true;
    const parsedDate = new Date(date.endsWith('Z') ? date : `${date}Z`);
    return moment(parsedDate).locale(locale).isBefore(moment(new Date(Date.now())));
}

export const diffBetweenDateAndNow = (date: string, locale: string): number => {
    if(!date || !date.length) return 0;
    const parsedDate = new Date(date.endsWith('Z') ? date : `${date}Z`);
    return moment(parsedDate).locale(locale).diff(moment(new Date(Date.now())), 'days');
}

export const isSameDay = (a: string | null | undefined, b: string | null | undefined, locale: string): boolean => {
    if(!a || !b) return false;
    try{
        const dateA = new Date(Date.parse(a)).toISOString();
        const dateB = new Date(Date.parse(b)).toISOString();
        return moment(dateA).locale(locale).isSame(moment(dateB).locale(locale), 'day');
    }catch (ex){
        Logging.log(ex);
        return false;
    }
}

export const isFutureDate = (a: string | null | undefined, locale: string, fromDate?: string | null | undefined): boolean => {
    // console.log(`isFutureDate`, a, locale, fromDate)
    if(!a) return false;
    try {
        const dateA = new Date(Date.parse(a)).toISOString();
        const dateB = fromDate ? new Date(Date.parse(fromDate)).toISOString() : new Date().toISOString();

        return moment(dateA).locale(locale).isAfter(moment(dateB).locale(locale))
    }catch (ex){
        Logging.log(ex);
        return false;
    }
}

export const isPastDate = (a: string | null | undefined, locale: string, toDate?: string | null | undefined): boolean => {
    if(!a) return false;
    try {
        const dateA = new Date(Date.parse(a));
        const dateB = toDate ? new Date(Date.parse(toDate)).toISOString() : new Date().toISOString();
        // console.log(`isPastDate`, moment(dateA).utc(true).locale(locale), moment(dateB).locale(locale))
        return moment(dateA).locale(locale).isSameOrBefore(moment(dateB).locale(locale))
    }catch (ex){
        Logging.log(ex);
        return false;
    }
}

export const getNormalizedForBackendDateDay = (date: string): string => {
    return date?.slice(0, '2022-07-15T10:19:26'.length) || date;
}

export const getMsFromDays = (days: number): number => {
    return days * 24 * 60 * 60 * 1000;
}

export const getDaysFromMs = (ms: number): number => {
    return Math.floor(ms / (24 * 60 * 60 * 1000));
}